<template>
    <div class="container">
        <div class="agent-register-ver-code">
            <h1 class="page_h1">請輸入驗證碼</h1>
            <div class="form f-row">
                <div class="register_step">
                    <p class="register_txt">請於手機簡訊接收驗證碼，並填入下方欄位</p>
                </div>
                <formInupt label="驗證碼" v-model.trim="req.code" :error="error.code" maxlength="6"/>
                <div class="form_grp f-col@lg:auto align:r mg-t-12">
                    <button class="btn w:full clr:primary" @click="onclick">繼續</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// @ is an alias to /src
import formInupt from '../../../components/form/input.vue'
import Validator from "../../../libs/Validator";
import Response from "../../../libs/Response";
import {mapGetters, mapState} from "vuex";

export default {
    name: 'enterVerCode',
    components: {
        formInupt,
    },
    data(){
        return {
            req:{
                token:'',
                code:''
            },
            error:{
                token:'',
                code:''
            }
        }
    },
    mounted() {
        const vm = this
        if(!vm.$route.params.hasOwnProperty('token')){
            console.log(vm.$route.params.token)
            vm.$router.replace({name:'forget_password', params:{}})
        }
    },
    beforeRouteEnter (to, from, next) {
        // 在渲染该组件的对应路由被 confirm 前调用
        // 不！能！获取组件实例 `this`
        // 因为当守卫执行前，组件实例还没被创建
        if(!to.params.hasOwnProperty('token')){
            console.log(to.params.token)
            next('/forget_password')
        }
        next()
    },
    methods:{
        async onclick(){
            const vm = this
            try{
                vm.req.token = vm.$route.params.token
                const validator = Validator.make(vm.req,{
                    code:['required','min:6','max:6','numeric'],
                    token:['required']
                })
                if (validator.fails()) {
                    console.log(validator._errors)
                    throw Response.create(validator.errors())
                }
                this.$store.commit('setLoadingStatus',true)
                const res = await vm.$axios.post('/api/enter_verify_code', vm.req);
                this.$store.commit('setLoadingStatus',false)
                vm.$router.push({name:'reset_password',params:{success_token:res.data.success_token}});

            }catch (e) {
                this.$store.commit('setLoadingStatus',false)
                if(e.code === 510){
                    vm.$store.commit('setModalMessage','驗證碼已過時，請重新發送')
                    vm.$router.replace({name:'forget_password',params:{}});
                    return
                }
                vm.error = e.response.data
            }

        }
    },
    computed:{
        ...mapState([
            'parentClass'
        ]),
        ...mapGetters([
            'registerClassName'
        ])
    }
}
</script>

<style lang="scss" scoped>
.router_link {
    font-size: 0.875rem;
}
.reset-mg\:b {
    margin-bottom: 0.75rem;
}
</style>
